module.exports = __webpack_public_path__ + "static/media/[Audio]2010-07-18-5.dbc90c03.md";